import { render, staticRenderFns } from "./DTPaginatorComponent.vue?vue&type=template&id=b7a0a408&scoped=true&"
import script from "./DTPaginatorComponent.vue?vue&type=script&lang=js&"
export * from "./DTPaginatorComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7a0a408",
  null
  
)

export default component.exports